import React from 'react';

const InlineLoading = ({ label = '', className = '' }) => {
  const showLabel = Boolean(label);
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-live="polite">
      {showLabel && <span>{label}</span>}
      <span className="inline-flex items-center gap-1" aria-hidden="true">
        {Array.from({ length: 3 }).map((_, index) => (
          <span
            key={index}
            className="inline-block h-1.5 w-1.5 rounded-full bg-current animate-bounce"
            style={{ animationDelay: `${index * 0.12}s` }}
          />
        ))}
      </span>
    </span>
  );
};

export default InlineLoading;
